import { jsx as _jsx } from "react/jsx-runtime";
import squareIcon from '@/core/svg/fa/square.svg';
import { ColorSquareIconStyled } from './ColorSquareIcon.styled';
const ColorSquareIcon = (props) => {
    return _jsx(ColorSquareIconStyled, { ...props, icon: squareIcon });
};
export { ColorSquareIcon };
